function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M13.47 12.004l8.29-8.29a1 1 0 00-1.41-1.41l-8.29 8.29-8.29-8.3a1.004 1.004 0 10-1.42 1.42l8.3 8.29-8.3 8.29a1 1 0 101.41 1.41l8.3-8.29 8.29 8.29a1 1 0 001.41-1.41l-8.29-8.29z"
});
function SvgClose(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none"
  }, props), _ref);
}
export default SvgClose;